import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { DemoService } from './services/demo.service';

import { AuthGuard } from './guards/auth.guard';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { SecurityService } from './services/security.service';

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule
    ],
    declarations: [

    ],
    providers: [
        DemoService,
        AuthGuard,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true
        },
        SecurityService
    ],
    exports: [

    ]
})
export class SharedServicesModule {
    constructor(@Optional() @SkipSelf() parentModule: SharedServicesModule) {
        const moduleName = 'SharedServicesModule';
        if (parentModule) {
            throw new Error(`${moduleName} has already been loaded`);
        }
    }
}
